import { BudgetRequestAdjustmentTypeEnum } from '@zaoblako/shared/modules/task/enum/budget-request-adjustment-type.enum';
import { BudgetRequestAdjustmentTypeEnumI18n } from '@zaoblako/shared/modules/task/i18n/budget-request-adjustment-type-enum.i18n';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import type { DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';

import * as yup from 'yup';

/** Budget request item create/update request body */
export interface BudgetRequestItemFormInterface {
  /** Related direction */
  direction: DirectionFindInterface;
  /** Amount value */
  amount: number;
  /** Adjustment type */
  adjustmentType?: BudgetRequestAdjustmentTypeEnum;
  /** Sub-items (for hierarchy mode) */
  children?: BudgetRequestItemFormInterface[];
}

/** Budget request item create/update request body - DTO schema */
export const BudgetRequestItemFormDto = SerdeDtoClass.create<BudgetRequestItemFormInterface>(TaskDtoKeysEnum.BUDGET_REQUEST_ITEM_FORM_DTO, {
  direction: {
    label: 'БС',
    checkers: [CatalogCheckersEnum.DIRECTION_ASSERT_EXISTS_BY_DTO],
    serializer: entityLikeSchema,
  },
  amount: {
    label: 'Сумма',
    serializer: yup
      .number()
      .min(0, DtoMessageEnum.NOT_ZERO_OR_POSITIVE),
  },
  adjustmentType: {
    optional: true,
    label: 'Тип корректировки',
    serializer: commonEnumValidator(BudgetRequestAdjustmentTypeEnum, BudgetRequestAdjustmentTypeEnumI18n),
  },
  children: {
    optional: true,
    label: 'Подстроки',
    nested: TaskDtoKeysEnum.BUDGET_REQUEST_ITEM_FORM_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
});
